import React, { PropsWithChildren } from 'react'
import { If } from '@paytrace/pt-skel/Component'
import { Chevron } from './Icons'
import './Accordion.css'

interface AccordionProps extends PropsWithChildren {
  title: string
  isOpen: boolean
  onToggle: () => void
  controls?: React.ReactNode
}

const Accordion = ({ title, isOpen, onToggle, controls, children }: AccordionProps) => {
  return (
    <div className="accordion-wrapper">
      <button
        className="accordion-header tranx_accordion btn btn-primary"
        data-target="#results_summary"
        data-toggle="collapse"
        type="button"
        onClick={onToggle}
      >
        <div className="accordion-title-group header">
          <span
            className={`chevron ${isOpen ? 'open' : ''}`}
          >
            <Chevron direction={ isOpen ? 'down' : 'right' } />
          </span>
          <span className="accordion-title title">{title}</span>
        </div>
      </button>

      {/* The Collapsible Body */}
      <div className={`accordion-collapse ${isOpen ? 'open' : ''}`}>
        <div className="accordion-body">

          <If is={controls !== undefined && controls !== null}>
            <div className="accordion-controls-bar">
              <div className="transaction-section-controls">
              {controls}
              </div>
            </div>
          </If>

          <div className="accordion-content">{children}</div>
        </div>
      </div>
    </div>
  )
}

export default Accordion
